import { Component, OnInit } from '@angular/core';
import { Client } from '../../../../classes/Client';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

  clientsData: Client[] = [];
  contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;


  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Clients' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {

    this.model.getClientsData( ( clData ) => {
        this.contentVisible = true;
        this.clientsData = clData;
    }, 'updated_at');

  }


}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/clients/clients/clients.component.ts